export enum DocumentType {
  AuthorizationForm = 'AuthorizationForm',
  CertificateOfOrigin = 'CertificateOfOrigin',
  Declaration = 'Declaration',
  ExportAccompanyingDocument = 'ExportAccompanyingDocument',
  ExportLicense = 'ExportLicense',
  ImportPermit = 'ImportPermit',
  OneTimeUSMCA = 'OneTimeUSMCA',
  Other = 'Other',
  PackingList = 'PackingList',
  PowerOfAttorney = 'PowerOfAttorney',
  SEDDocument = 'SEDDocument',
  ShippersLetterOfInstruction = 'ShippersLetterOfInstruction',
}

export const DocumentTypeLabels: Record<DocumentType, string> = {
  [DocumentType.AuthorizationForm]: 'Authorization Form',
  [DocumentType.CertificateOfOrigin]: 'Certificate of Origin',
  [DocumentType.Declaration]: 'Declaration',
  [DocumentType.ExportAccompanyingDocument]: 'Export Accompanying Document',
  [DocumentType.ExportLicense]: 'Export License',
  [DocumentType.ImportPermit]: 'Import Permit',
  [DocumentType.OneTimeUSMCA]: 'One Time USMCA',
  [DocumentType.Other]: 'Other Document',
  [DocumentType.PackingList]: 'Packing List',
  [DocumentType.PowerOfAttorney]: 'Power of Attorney',
  [DocumentType.SEDDocument]: 'SED Document',
  [DocumentType.ShippersLetterOfInstruction]: "Shipper's Letter of Instruction",
};

export type DocumentStatus = 'Processing' | 'Clean' | 'Failed';

export type DocumentSourceType = 'Upload';

export interface UploadDocument {
  documentId: string;
  source?: DocumentSourceType;
  documentType: string;
  originalFileName: string;
  fileExtension?: string;
  mimeType: string;
  sizeBytes?: number;
  status: DocumentStatus;
  trackingNo?: string;
  sha256?: string;
  createdUtc?: string;
  uploadedUtc?: string;
  failedReason?: string;
}

export const ALLOWED_EXTENSIONS = ['pdf', 'tif', 'tiff', 'jpg', 'jpeg', 'png', 'gif'];

export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'image/tiff',
  'image/jpeg',
  'image/png',
  'image/gif',
];

export const MAX_FILE_SIZE_MB = 10;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const MAX_DOCUMENTS = 10;

export const POLL_INTERVAL_MS = 3000;

export const FILE_ACCEPT = '.pdf,.tif,.tiff,.jpg,.jpeg,.png,.gif';
